import { TestBed } from '@angular/core/testing';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface SearchListInput {
  userName: string;
  searchDate: Date;
}
export interface SearchList{
  userName: string;
  ipAddress: string;
  searchDate: string;
  text: string;
  materialCode: string;
  country: string;
  language: string;
}

@Injectable({
  providedIn: 'root'
})
export class SearchActivityService {

  apiUrl = environment.apiURL;

  constructor(private http: HttpClient,private spinner:NgxSpinnerService) { }
  getSearchActivityResult(post: SearchListInput): Observable<SearchList> {
    this.spinner.show();
    return this.http.post<SearchList>(
      `${this.apiUrl}/rest/admin/search/report`,
      post
    );
  }
}
